<template>
  <div class="home-container">
    <el-carousel :interval="300000" trigger="click" indicator-position="outside" class="page-banner">
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <!-- <a :href="item.link || 'javascript:void(0)'" target="_blank"> -->
          <img class="banner-img" :src="$env.imgUrl + item.src" :alt="item.alt || ''">
        <!-- </a> -->
      </el-carousel-item>
    </el-carousel>
    <div class="safe-area section1">
      <!-- 1 -->
      <pageTitle cn="赛事核心信息" en="Annual Event Overview" type="1"></pageTitle>
      <div class="page-flex-lr-center">
        <div class="">
          <div class="d1">全球青少年PBL创新素养挑战赛 </div>
          <div class="page-flex-lr-top mb-14">
            <div class="label">
              <div class="cn">活动时间</div>
              <div class="en">Event Time</div>
            </div>
            <div class="value1">2026年11月27日 - 11月29日</div>
          </div>
          <div class="page-flex-lr-top mb-14">
            <div class="label">
              <div class="cn">举办城市</div>
              <div class="en">Host City</div>
            </div>
            <div class="value1">中国・深圳</div>
          </div>
          <div class="page-flex-lr-top mb-14">
            <div class="label">
              <div class="cn">核心定位</div>
              <div class="en">Core Focus</div>
            </div>
            <div class="value2">
              <div class="cn">面向全国公办、民办、国际以及IB学校等不同教育体系学校，面向全球青少年的顶级 PBL 综合展演平台，融合非遗人文、海洋科学、AI 科创、财商四大探究赛道，打造一站式国际素养成长赛事，帮助青少年遇见未来新模样，培养天下精神与全球胜任力。</div>
              <div class="en">A top-tier global PBL showcase for youth from all school systems (public, private, international and IB), integrating four inquiry tracks—heritage humanities, marine science, AI innovation, and financial literacy. This one-stop competition fosters global competence and a cosmopolitan spirit, helping young people shape their future.</div>
            </div>
          </div>
        </div>
        <img class="home-pic-1" :src="$env.imgUrl + 'home-pic-1.png'" alt="">
      </div>
    </div>
    <!-- 2 -->
    <div class="page-flex-lr-center section2" :style="'background-image: url(' + $env.imgUrl + 'home-bg-1.png);'">
      <div class="safe-area">
        <pageTitle cn="主办合作机构" en="Host & Strategic Partners" type="2"></pageTitle>
        <div class="page-flex-lr-top">
          <div class="lf">
            <div class="page-flex-lr-top mt-30">
              <div class="vertical-title-black t1">
                <div class="cn">主办单位</div>
                <div class="en">Host Organization</div>
              </div>
              <div>
                <div class="d2">全球青少年PBL创新素养中心</div>
                <div class="d3">Global Center for Youth PBL Innovation & Literacy</div>
              </div>
            </div>
            <div class="page-flex-lr-top mt-30">
              <div class="vertical-title-black t2">
                <div class="cn">权威合作生态</div>
                <div class="en">Authority Partnership Ecosystem</div>
              </div>
              <div>
                <div class="d4">本赛事构建 “国际指引 – 国家指导 – 行业合作 – 高校联动”的全链条权威支撑体系，全程对标全球顶尖教育实践，确保专业性、学术性与国际认可度。</div>
                <div class="d5">This competition has established a comprehensive, authoritative support system based on the framework of “international guidelines—national guidance—industry collaboration—university partnerships,” aligning with the world’s leading educational practices throughout the entire process to ensure professionalism, academic rigor, and international recognition.</div>
              </div>
            </div>
          </div>
          <div class="rt">
            <div class="tab1">
              <div class="tab-item" :class="index === 0 ? 'active' : ''" @click="index = 0">
                <div class="cn">A.国际组织专业指引</div>
                <div class="en">International Professional Guidance</div>
              </div>
              <div class="tab-item" :class="index === 1 ? 'active' : ''" @click="index = 1">
                <div class="cn">B.国家级学术引领</div>
                <div class="en">National Academic Leadership</div>
              </div>
              <div class="tab-item" :class="index === 2 ? 'active' : ''" @click="index = 2">
                <div class="cn">C.行业领军合作</div>
                <div class="en">Industry Partners</div>
              </div>
              <div class="tab-item" :class="index === 3 ? 'active' : ''" @click="index = 3">
                <div class="cn">D.高校产学研联动</div>
                <div class="en">University Cooperation</div>
              </div>
            </div>
            <div class="img-box">
              <template v-if="index === 0">
                <div class="">
                  <img class="s2-img" :src="$env.imgUrl + 's2-a1.png'" alt="">
                  <img class="s2-img" :src="$env.imgUrl + 's2-a2.png'" alt="">
                  <img class="s2-img" :src="$env.imgUrl + 's2-a3.png'" alt="">
                </div>
              </template>
              <template v-if="index === 1">
                <img class="s2-img" :src="$env.imgUrl + 's2-b1.png'" alt="">
                <img class="s2-img" :src="$env.imgUrl + 's2-b2.png'" alt="">
              </template>
              <template v-if="index === 2">
                <div class="w1150">
                  <img class="s2-img" :src="$env.imgUrl + 's2-c1.png'" alt="">
                  <img class="s2-img" :src="$env.imgUrl + 's2-c2.png'" alt="">
                  <img class="s2-img" :src="$env.imgUrl + 's2-c3.png'" alt="">
                  <img class="s2-img" :src="$env.imgUrl + 's2-c4.png'" alt="">
                  <img class="s2-img" :src="$env.imgUrl + 's2-c5.png'" alt="">
                </div>
              </template>
              <template v-if="index === 3">
                <div class="w1360">
                  <img class="s2-img" :src="$env.imgUrl + 's2-d1.png'" alt="">
                  <img class="s2-img" :src="$env.imgUrl + 's2-d2.png'" alt="">
                  <img class="s2-img" :src="$env.imgUrl + 's2-d3.png'" alt="">
                  <img class="s2-img" :src="$env.imgUrl + 's2-d4.png'" alt="">
                  <img class="s2-img" :src="$env.imgUrl + 's2-d5.png'" alt="">
                  <img class="s2-img" :src="$env.imgUrl + 's2-d6.png'" alt="">
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 3 -->
    <div class="safe-area">
      <div class="section3">
        <div class="page-flex-lr-top">
          <div class="w32">
            <pageTitle cn="往期参赛反馈" en="Voices of Participants" type="1"></pageTitle>
            <div class="d6">每一次参赛，都藏着独一无二的成长故事。来自全国各地的师生与家长，分享他们的参赛真实体验。</div>
            <div class="d7">Every challenge leaves an inspiring story. Read firsthand feedback from educators, students and families across regions.</div>
            <div class="page-btn">
              <div class="cn">点击分享</div>
              <div class="en">Click to Share</div>
            </div>
          </div>
          <img class="s3-img w68" :src="$env.imgUrl + 's3.png'" alt="">
        </div>
        <div class="d8">关于PBL，古往今来名家们这样说：</div>
        <div class="d9">Regarding PBL, famous scholars throughout history have said:</div>
        <div class="card-box" ref="cardBox">
          <div class="card-box-track">
            <!-- 第一组 -->
            <div class="card-tit">古老智慧溯源</div>
            <img :src="$env.imgUrl + 's3-1.png'" alt="">
            <div class="card-tit">现代思想源泉</div>
            <img :src="$env.imgUrl + 's3-2.png'" alt="">
            <img :src="$env.imgUrl + 's3-3.png'" alt="">
            <img :src="$env.imgUrl + 's3-4.png'" alt="">
            <div class="card-tit">当代教育研究</div>
            <img :src="$env.imgUrl + 's3-6.png'" alt="">
            <img :src="$env.imgUrl + 's3-7.png'" alt="">
            <!-- 第二组（无缝循环复制） -->
            <div class="card-tit">古老智慧溯源</div>
            <img :src="$env.imgUrl + 's3-1.png'" alt="">
            <div class="card-tit">现代思想源泉</div>
            <img :src="$env.imgUrl + 's3-2.png'" alt="">
            <img :src="$env.imgUrl + 's3-3.png'" alt="">
            <img :src="$env.imgUrl + 's3-4.png'" alt="">
            <div class="card-tit">当代教育研究</div>
            <img :src="$env.imgUrl + 's3-6.png'" alt="">
            <img :src="$env.imgUrl + 's3-7.png'" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- 4 -->
    <div class="section4" :style="'background-image: url(' + $env.imgUrl + 'home-bg-2.png);'">
      <div class="safe-area">
        <div class="page-flex-lr-center">
          <div class="lf w32">
            <pageTitle cn="优秀作品展厅" en="Outstanding Works Gallery" type="2"></pageTitle>
            <div class="d10">线上永久展示历年全国获奖参赛项目，完整留存研究报告、实物作品、展演视频，供各校备赛参考学习。</div>
            <div class="d11">Permanently display all award-winning entries from previous years online, and fully preserve research reports, physical works, and exhibition videos for reference and learning by schools preparing for competitions.</div>
            <div class="page-btn page-btn1" @click="nextFn">
              <div class="cn">前往展厅</div>
              <div class="en">Head to the exhibition hall</div>
            </div>
          </div>
          <div class="rt w68 page-flex-lr-center">
            <div class="video">
              <video class="video-player" :src="$env.imgUrl + 'v1.mp4'" :poster="$env.imgUrl + 'poster.png'" controls></video>
              <!-- <img class="s4-1" :src="$env.imgUrl + 'poster.png'" alt=""> -->
            </div>
            <div class="rt-img">
              <img class="s4-2" :src="$env.imgUrl + 's4-1.png'" alt="">
              <img class="s4-3" :src="$env.imgUrl + 's4-2.png'" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 5 -->
    <!-- <div class="safe-area">
      <div class="section5">
        <pageTitle cn="官方咨询通道" en="Official Channel" type="1"></pageTitle>
        <div class="btn-group">
          <div class="btn-item">
            <div class="cn">立即组队报名</div>
            <div class="en">Secure Your Team Spot</div>
          </div>
          <div class="btn-item">
            <div class="cn">战队注册相关信息</div>
            <div class="en">Information related to team registration</div>
          </div>
          <div class="btn-item">
            <div class="cn">下载备赛指南</div>
            <div class="en">Download Preparation Guide</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'Home2026',
  data() {
    return {
      index: 0,
      bannerList: [
        { src: 'banner-home-1.jpg?v=202609', link: '', alt: '' },
        { src: 'banner-home-2.jpg?v=202608', link: '', alt: '' }
        // { src: 'banner-home.png?v=20260810', link: '', alt: '' }
      ]
    }
  },
  created() {
    this.$store.dispatch('SET_MENUINDEX', 0)
  },
  methods: {
    nextFn () {
      this.$router.push('/case')
    }
  }
}
</script>

<style lang="less" scoped>
.home-container{
  width: 100vw;
  overflow-x: hidden;
}
/deep/ .el-carousel__container{
  height: 660px;
}
/deep/ .el-carousel__item{
  background-color: transparent;
}
/deep/ .el-carousel__button{
  width: 40px;
  height: 4px;
  border-radius: 4px;
}
/deep/ .el-carousel__indicators--outside button{
  background-color: #C9273A;
}
.page-banner{
  width: 100vw;
  height: 720px;
  overflow: hidden;
  margin-bottom: 30px;
}
.banner-img{
  width: 100vw;
  height: 660px;
  object-fit: cover;
  display: block;
}
.d1{
  color: #000;
  font-family: systh;
  font-size: 22px;
  margin-top: 14px;
  margin-bottom: 20px;
}
.label{
  background-color: #C9273A;
  color: #fff;
  padding: 6px 10px 4px;
  border-radius: 8px;
  margin-right: 20px;
  text-align: center;
  width: 60px;
  .cn{
    font-family: alih;
    font-size: 14px;
    line-height: 16px;
  }
  .en{
    font-size: 10px;
    line-height: 12px;
  }
}
.value1{
  font-family: systm;
  font-size: 16px;
  color: #C9273A;
  padding-top: 4px;
}
.value2{
  flex: 1;
  .cn{
    font-family: systm;
    font-size: 12px;
    color: #000;
    margin-bottom: 4px;
  }
  .en{
    font-family: systm;
    font-size: 9px;
    color: #666;
    text-align: justify;
  }
}
.mb-14{
  margin-bottom: 14px;
}
.mt-30{
  margin-top: 20px;
}
.home-pic-1{
  width: 60%;
  height: 320px;
  object-fit: cover;
  margin-left: 20px;
  border-radius: 16px;
}
.section1{
  margin-bottom: 18px;
}
.section2{
  width: 100%;
  min-height: 200px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  padding: 120px 0;
  .lf{
    width: 340px;
  }
  .rt{
    flex: 1;
    margin-left: 30px;
    margin-top: 30px;
  }
}
.vertical-title-black{
  color: #fff;
  background-color: #000;
  padding: 12px 0;
  width: 36px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .cn{
    width: 24px;
    font-family: alih;
    font-size: 14px;
    line-height: 18px;
  }
  .en{
    position: absolute;
    left: -14px;
    font-size: 10px;
    width: fit-content;
    white-space: nowrap;
    transform: rotate(90deg);
  }
  &.t2{
    height: 160px;
    .en{
      left: -46px;
    }
  }
  &.t1{
    height: 100px;
  }
}
.d2{
  font-size: 22px;
  font-family: systh;
  color: #fff;
  width: 240px;
  margin-left: 20px;
}
.d3{
  font-size: 12px;
  font-family: systm;
  color: #FD8E86;
  width: 240px;
  margin-left: 20px;
  margin-top: 8px;
}
.d4{
  font-size: 14px;
  font-family: systm;
  color: #fff;
  width: 280px;
  margin-left: 20px;
}
.d5{
  font-size: 10px;
  font-family: systm;
  color: #FD8E86;
  width: 280px;
  margin-left: 20px;
  margin-top: 8px;
  text-align: justify;
}
.tab1{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .tab-item{
    width: 164px;
    height: 40px;
    text-align: center;
    background-color: #000;
    border-radius: 46px;
    padding-top: 6px;
    cursor: pointer;
    box-sizing: border-box;
    .cn{
      font-size: 14px;
      font-family: systh;
      color: #fff;
    }
    .en{
      font-size: 9px;
      font-family: systh;
      color: #999;
    }
    &.active{
      background-color: #fff;
      .cn{
        color: #CC3446;
      }
      .en{
        color: #FD8E86;
      }
    }
  }
}
.img-box{
  margin-top: 20px;
  width: 700px;
  overflow-x: auto;
  .w1150{
    width: 1150px;
    text-align: left;
  }
  .w1360{
    width: 1360px;
    text-align: left;
  }
}
.s2-img{
  width: auto;
  height: 260px;
  margin-right: 20px;
}
.s2-img1{
  width: 15%;
  height: auto;
  margin-top: 60px;
}
.s2-img2{
  width: 45%;
  height: auto;
  // height: 360px;
  margin-top: 20px;
}
.d6{
  font-family: systm;
  font-size: 14px;
  color: #000;
  width: 320px;
  margin-top: 30px;
}
.d7{
  font-family: systm;
  font-size: 10px;
  color: #666;
  width: 320px;
  margin-top: 16px;
  margin-bottom: 40px;
  text-align: justify;
}
.section3{
  padding: 40px 0;
}
.w32{
  width: 32%;
}
.w68{
  width: 68%;
}
.s3-img{
  margin-left: 20px;
  height: 300px;
  object-fit: cover;
  border-radius: 16px;
}
.d8{
  color: #C9273A;
  font-size: 20px;
  font-family: systh;
  margin-top: 40px;
}
.d9{
  color: #C9273A;
  font-size: 12px;
  font-family: systh;
}

.section4{
  background-repeat: no-repeat;
  background-size: 100% auto;
  padding: 100px 0 40px;
  .lf{
    width: 30%;
  }
  .rt{
    flex: 1;
    margin-left: 20px;
  }
  .video{
    width: 480px;
    height: 270px;
    margin-right: 20px;
    border-radius: 20px;
    .video-player{
      width: 480px;
      height: 270px;
      border-radius: 20px;
    }
  }
}
.card-box{
  overflow: hidden;
  margin-top: 30px;
  position: relative;
  border-radius: 20px;
  // 两端渐变遮罩
  &::before, &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 60px;
    z-index: 2;
    pointer-events: none;
  }
  &::before {
    left: 0;
    background: linear-gradient(to right, #fff, transparent);
  }
  &::after {
    right: 0;
    background: linear-gradient(to left, #fff, transparent);
  }
  &:hover .card-box-track {
    animation-play-state: paused;
  }
}
.card-box-track{
  display: flex;
  align-items: stretch;  // 让标题和图片高度一致
  width: max-content;
  img{
    width: 240px;
    height: 320px;
    // width: calc((100vw - 80px) / 4);  // 一屏显示4张图片，减去左右渐变遮罩
    // height: calc((100vw - 80px) / 4 * 1.35);  // 按图片实际比例调整高度
    // max-width: 320px;
    // max-height: 432px;
    // min-width: 180px;
    // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    border-radius: 16px;
    margin: 0 6px;
    flex-shrink: 0;
    object-fit: cover;
  }
  .card-tit{
    font-family: regular;
    font-size: 16px;
    color: #C9273A;
    writing-mode: vertical-rl;  // 文字竖排，从右到左
    text-orientation: upright;   // 字符直立
    letter-spacing: 2px;        // 竖排字符间距
    padding: 12px 0;
    margin: 0 6px;
    flex-shrink: 0;
    border-radius: 8px;
    width: auto;
    min-width: unset;
  }
  // 横向循环滚动动画：向左滚动50%（一组内容的宽度），无缝衔接
  animation: cardScroll 40s linear infinite;
  &:hover {
    animation-play-state: paused;
  }
}
@keyframes cardScroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
.d10{
  font-family: systm;
  font-size: 14px;
  color: #fff;
  margin-top: 20px;
  margin-bottom: 10px;
}
.d11{
  font-family: systm;
  font-size: 10px;
  color: #FD8E86;
  margin-bottom: 40px;
  text-align: justify;
}
.s4-1{
  width: 60%;
  height: 260px;
  margin-right: 20px;
  margin-left: 20px;
  object-fit: cover;
  border-radius: 20px;
}
.rt-img{
  width: 40%;
}
.s4-2{
  width: 100%;
  height: 120px;
  margin-bottom: 20px;
  object-fit: cover;
  border-radius: 20px;
}
.s4-3{
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 20px;
}
.section5{
  padding-bottom: 100px;
}
.btn-group{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.btn-item{
  width: 28%;
  background-color: #C9273A;
  border-radius: 14px;
  padding-top: 10px;
  padding-bottom: 14px;
  text-align: center;
  margin-top: 60px;
  cursor: pointer;
  .cn{
    font-family: systh;
    font-size: 20px;
    color: #fff;
  }
  .en{
    font-family: systh;
    font-size: 10px;
    color: #FD8E86;
  }
  &:hover{
    box-shadow: 0 4px 12px rgba(248, 46, 46, 0.5);
  }
}
</style>
